import Vue from 'vue'
import App from './App.vue'

import VueAxios from "vue-axios";
import axios from "axios";
import VueCookies from "vue-cookies";
import Lightbox from 'vue-easy-lightbox';
import JsonExcel from "vue-json-excel";
import VueHead from 'vue-head'

import router from './router'
import store from './store'
import i18n from './i18n'

Vue.config.productionTip = false

Vue.use(VueHead)
Vue.use(Lightbox)
Vue.use(VueAxios, axios)
Vue.use(VueCookies)
Vue.component("downloadExcel", JsonExcel);

export const bus = new Vue();

new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app')

store.$i18n = i18n